import { render, staticRenderFns } from "./UserApiAccess.vue?vue&type=template&id=0c526b13&scoped=true&"
import script from "./UserApiAccess.vue?vue&type=script&lang=js&"
export * from "./UserApiAccess.vue?vue&type=script&lang=js&"
import style0 from "./UserApiAccess.vue?vue&type=style&index=0&id=0c526b13&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c526b13",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c526b13')) {
      api.createRecord('0c526b13', component.options)
    } else {
      api.reload('0c526b13', component.options)
    }
    module.hot.accept("./UserApiAccess.vue?vue&type=template&id=0c526b13&scoped=true&", function () {
      api.rerender('0c526b13', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/UserApiAccess.vue"
export default component.exports